import { render, staticRenderFns } from "./companyOverview.vue?vue&type=template&id=0f0af27c&scoped=true&"
import script from "./companyOverview.vue?vue&type=script&lang=js&"
export * from "./companyOverview.vue?vue&type=script&lang=js&"
import style0 from "./companyOverview.vue?vue&type=style&index=0&id=0f0af27c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0af27c",
  null
  
)

export default component.exports